function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { createContext, useContext, useEffect, useState } from 'react';

/** Function for unsubscribing from a given subscription */

/** Update when the ObjectFetch is still loading */

/** Update when the ObjectFetch has errored */

/** Update when the object is ready */

/**
 * Update with the current `fetch` function and status of the object.
 * - If both `fetch` and `error` are `null`, it is still loading the fetcher
 * - If `fetch` is not `null`, the object is ready to be fetched
 * - If `error` is not `null`, there was an error loading the object
 */

/** ObjectFetchManager for managing a subscription to an object using a VariableDescriptor */

/** Context for tracking an implementation of the ObjectFetchManager. */
export var ObjectFetchManagerContext = /*#__PURE__*/createContext(null);
ObjectFetchManagerContext.displayName = 'ObjectFetchManagerContext';

/**
 * Retrieve a `fetch` function for the given variable descriptor.
 *
 * @param descriptor Descriptor or URI to get the `fetch` function for
 * @returns An object with the current `fetch` function, OR an error status set if there was an issue fetching the object.
 *          Retrying is left up to the ObjectManager implementation used from this context.
 */
export function useObjectFetch(descriptor) {
  var _useState = useState({
      status: 'loading'
    }),
    _useState2 = _slicedToArray(_useState, 2),
    currentUpdate = _useState2[0],
    setCurrentUpdate = _useState2[1];
  var objectFetchManager = useContext(ObjectFetchManagerContext);
  useEffect(() => {
    if (objectFetchManager == null) {
      setCurrentUpdate({
        error: new Error('No ObjectFetchManager available in context'),
        status: 'error'
      });
      return;
    }
    // Update to signal we're still loading, if we're not already in a loading state.
    setCurrentUpdate(oldUpdate => oldUpdate.status === 'loading' ? oldUpdate : {
      status: 'loading'
    });
    return objectFetchManager.subscribe(descriptor, setCurrentUpdate);
  }, [descriptor, objectFetchManager]);
  return currentUpdate;
}
//# sourceMappingURL=useObjectFetch.js.map